namespace GeniuzPOS.Lookups {
    export namespace VwSkuLookupPurchaseService {
        export const baseUrl = 'Lookups/VwSkuLookupPurchase';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwSkuLookupPurchaseRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwSkuLookupPurchaseRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwSkuLookupPurchase/Retrieve",
            List = "Lookups/VwSkuLookupPurchase/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwSkuLookupPurchaseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
